import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TopNavBar from "app/layout/TopNavBar";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const sampleHistory = [
  {
    id: 1,
    title: "Shuba Muhurtha - 2026-09",
    event: "Shuba Welawan",
    createdAt: "2026-08-29",
    status: "Completed",
  },
  {
    id: 2,
    title: "Shuba Muhurtha - 2026-10",
    event: "Shuba Punyakalam",
    createdAt: "2026-08-15",
    status: "Completed",
  },
];

function ShubaMuhurtha() {
  const navigate = useNavigate();
  const [history] = useState(sampleHistory);

  return (
    <DashboardLayout>
      <TopNavBar />
      <MDBox pt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                <MDTypography variant="h4" fontWeight="bold">
                  Shuba Muhurtha
                </MDTypography>
                <MDButton
                  variant="contained"
                  color="info"
                  onClick={() => navigate("/my-files/shuba-muhurtha/new")}
                  startIcon={<span style={{ fontSize: 20, lineHeight: 1 }}>+</span>}
                >
                  Search new Shuba Muhurtha
                </MDButton>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <MDTypography variant="h6" sx={{ mb: 2 }}>
                Historical searches
              </MDTypography>

              <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Title</TableCell>
                      <TableCell>Event</TableCell>
                      <TableCell>Created</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {history.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          No Shuba Muhurtha records yet.
                        </TableCell>
                      </TableRow>
                    ) : (
                      history.map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell>{row.title}</TableCell>
                          <TableCell>{row.event}</TableCell>
                          <TableCell>{row.createdAt}</TableCell>
                          <TableCell>{row.status}</TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ShubaMuhurtha;
